import { useEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import {
  MainPage,
  DeviceSetupPageV2,
  LoginPage,
  CreateMeetingPage,
  ObserverPage,
  NotFoundPage,
  DeviceDetectPage,
} from 'views';
import { JoinMeetingRedirect } from 'containers';
import ReactGA from 'react-ga4';
import { ErrorBoundary } from 'components';
import { useQuery } from 'utils/hooks/useQuery';
import { Roles } from 'constants/index';

const App = () => {
  const query = useQuery();
  const { role } = query;

  useEffect(() => {
    try {
      const isTargetRole = role === Roles.Teacher || role === Roles.Student;
      if (process.env.REACT_APP_GA_TRACKING_ID && isTargetRole) {
        ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);
        ReactGA.send('pageview');
      }
    } catch (error) {
      console.warn('GA initialization failed:', error);
    }
  }, [role]);

  return (
    <ErrorBoundary>
      <Switch>
        <Route exact path='/'>
          <Redirect to='/notFound' />
        </Route>
        <Route path='/login' component={LoginPage} />
        <Route path='/create' component={CreateMeetingPage} />
        <Route path='/deviceDetect' component={DeviceDetectPage} />
        <Route exact path='/:meetingId/setup' component={DeviceSetupPageV2} />
        <Route exact path='/:meetingId/observer' component={ObserverPage} />
        <Route exact path='/:meetingId/breakout/:breakoutId/observer' component={ObserverPage} />
        <Route exact path='/:meetingId/breakout/:breakoutId' component={MainPage} />
        <Route path='/notFound' component={NotFoundPage} />
        <Route
          exact
          path='/:meetingId'
          component={() => (
            <JoinMeetingRedirect>
              <MainPage />
            </JoinMeetingRedirect>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};
export default App;
